import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestPropertyModel } from '@shared/interfaces/rest-portfolio-model.interface';

export function getPortfolioProperties(userProperties: RestPropertyModel[]): IRadioButtonOption<number>[] {
  return userProperties
    .map<IRadioButtonOption<number>>(item => {
      return {
        value: item.id,
        label: item.name,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}
